// removed by extract-text-webpack-plugin
module.exports = {"container":"_1y7m9","date":"_1lIVB","updates-list":"_2pZ8k","updates-timeline-container":"_2N75O","updates-first-item-container":"_3ve0E","updates-timeline-marker":"_19TEN","updates-first-item-marker-container":"_1qmZt","updates-first-item-description":"_3qUxc","updates-first-item-marker":"QLO8P","avatar-container":"_1f6-w","avatar-image":"_3xRED","supporters":"_3jfuW","supporter":"_1G7cE","action":"FLi3S","action-box":"CHj_R","item":"LRyXQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Updates/Updates.scss
// module id = ./src/components/Updates/Updates.scss
// module chunks = 5